export default __webpack_public_path__ + "static/media/sign-draw-icon.e2a45010.svg";